import CarouselUserView from "./CarouselUserView";

export default CarouselUserView;
